var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    _setup.FormControlUrlSlug,
    _vm._g(_vm._b({}, "FormControlUrlSlug", _vm.$props, false), _vm.$listeners)
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }